import React from 'react';
import { Link } from 'components';
import map from 'lodash/map';

const Item = ({ slug, image, title, artists, authors, price, dates, to }) => {
  // The API's `authors` is the primary credit: it falls back through artist \u2192
  // author \u2192 editor \u2192 writer, so publications without an artist still get a
  // name here instead of an empty line. `artists` covers feeds that omit it.
  const credits = (Array.isArray(authors) && authors.length) ? authors : artists;
  const formatNames = (people) => {
    const names = map(people, (a) => a.name);
    return names.length > 3 ? (
      `${names.slice(0, 3).join(', ')}\u00A0+${names.length - 3}`
    )
      : names.join(', ');
  };

  return (
    <div className="Item">
      <Link to={`${to ? to : '/item/'}${slug}`} className="Link item-link">
        <div className="item-img-container">
          {/* 3x4 #c2c2c2 https://png-pixel.com/ */}
          <img src={image} alt={title} onError={(e) => { e.target.onerror = null; e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAQAAADhJE2MAAAAEElEQVR42mM89J8BCBixUQBwKAcJsCakLQAAAABJRU5ErkJggg=='; }} className="item-img" />
        </div>
        <div className="item-text">
          {
            (Array.isArray(credits) && credits.length) ? (
              <div className="item-artists">
                {formatNames(credits)}
              </div>
            )
              : <div className="item-artists">&nbsp;</div>
          }
          {dates && <div className="item-title">{dates}</div>}
          <div className="item-title">{title}</div>
          {price ? <div className="price-container"><div className="item-price">{price}</div></div> : null}
        </div>
      </Link>
    </div>
  );
};
const MemoItem = React.memo(Item);
export default MemoItem;
